import Home from 'src/pages/home'
import News from 'src/pages/news'
import NewsList from 'src/pages/news/List'
import NewsDetail from 'src/pages/news/Detail'
import Venue from 'src/pages/venue'
import VenueAerialView from 'src/pages/venue/AerialView'
import VenueDistributionMap from 'src/pages/venue/DistributionMap'
import Appointment from 'src/pages/appointment'
import Test from 'src/pages/test'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    redirect: '/news/list',
    children: [
      {
        path: 'list',
        name: 'NewsList',
        component: NewsList
      },
      {
        path: 'detail',
        name: 'NewsDetail',
        component: NewsDetail
      }
    ]
  },
  {
    path: '/venue',
    name: 'Venue',
    component: Venue,
    redirect: '/venue/aerial/view',
    children: [
      {
        path: 'aerial/view',
        name: 'VenueAerialView',
        component: VenueAerialView
      },
      {
        path: 'distribution/map',
        name: 'VenueDistributionMap',
        component: VenueDistributionMap
      }
    ]
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: Appointment
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js